import { render, staticRenderFns } from "./PaymentsAndCurrenciesPayments.vue?vue&type=template&id=a9f623b4&scoped=true&"
import script from "./PaymentsAndCurrenciesPayments.vue?vue&type=script&lang=js&"
export * from "./PaymentsAndCurrenciesPayments.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsAndCurrenciesPayments.vue?vue&type=style&index=0&id=a9f623b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f623b4",
  null
  
)

export default component.exports